<nb-card class="cd-dialog">
  <nb-card-header class="cd-header">
    <div class="cd-titles">
      <span class="cd-title">Schwierigkeits-Report</span>
      <span class="cd-sub">{{ course?.fullname || course?.shortname }}</span>
    </div>
    <button nbButton ghost size="small" (click)="close()" aria-label="Schließen">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body [nbSpinner]="loading" nbSpinnerStatus="primary">
    <p *ngIf="error" class="cd-empty">Report konnte nicht geladen werden.</p>

    <p *ngIf="!loading && !error && !items.length" class="cd-empty">
      Noch keine Antwortdaten für diesen Kurs. Der Report füllt sich, sobald
      Lernende den geführten Modus nutzen.
    </p>

    <ng-container *ngIf="items.length">
      <p class="cd-lead">Lernziele mit der höchsten Fehlerquote — die Stolpersteine im Kurs.</p>

      <div
        echarts
        [options]="chartOption"
        [autoResize]="true"
        theme="alphabees"
        class="cd-chart"
      ></div>

      <div class="cd-table-wrap">
        <table class="cd-table">
          <thead>
            <tr>
              <th>Kapitel / Lernziel</th>
              <th class="num">Fehlerquote</th>
              <th class="num">Versuche</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let i of items">
              <td>
                <span class="cd-chapter" *ngIf="i.chapter_title">{{ i.chapter_title }}</span>
                {{ i.objective || i.objective_id }}
              </td>
              <td class="num">
                <span
                  class="cd-pct"
                  [class.hot]="i.fail_rate >= 0.6"
                  [class.warm]="i.fail_rate >= 0.3 && i.fail_rate < 0.6"
                  >{{ failPct(i) }}%</span
                >
              </td>
              <td class="num">{{ i.attempts }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </nb-card-body>
</nb-card>
